module.exports = __webpack_public_path__ + "static/media/logo.c06c5262.png";